module.exports = __webpack_public_path__ + "static/media/logo.8e26f220.svg";